import { useState } from 'react'
import { useImmer } from 'use-immer'
import { InputContainer, GoogleAutocomplete } from 'components/ideal-core-ui'
import { Button } from 'reactstrap'
import { makePostRequest } from 'utils/api'
import { AutosuggestInput } from 'components/common/AutosuggestInput'
import s from '../../DealsModal.scss'
import cn from 'classnames'

const initialState = {
  name: '',
  legalName: '',
  address: '',
  address2: '',
  street2: '',
  city: '',
  state: '',
  zipcode: '',
  country: '',
  phone: '',
  additionalPhone: '',
  fax: ''
}

const AddCompany = ({ incrementKey }) => {
  const [company, setCompany] = useImmer(initialState)
  const [hasDuplicateError, setHasDuplicateError] = useState(false)

  const changeCompanyProperty = (value, property) => {
    setCompany(state => {
      state[property] = value
    })
  }

  const validateProperty = (value, suggestions) => {
    const error = !!suggestions.filter(
      suggestion => suggestion.title.trim().toLowerCase() === value.trim().toLowerCase()
    ).length
    setHasDuplicateError(error)
  }

  const onAddressSelectCallback = params => {
    const { address, city, state, zipCode, country, street } = params

    setCompany(companyState => {
      companyState.address = address
      companyState.address2 = street
      companyState.city = city
      companyState.state = state
      companyState.country = country
      companyState.zipcode = zipCode
    })
  }

  const saveCompany = async () => {
    try {
      const formData = new FormData()
      formData.append(
        'companyData',
        JSON.stringify({
          ...company
        })
      )

      await makePostRequest('/v1/companies', formData)
      incrementKey()
      setCompany(initialState)
      setHasDuplicateError(false)
      // eslint-disable-next-line no-empty
    } catch (e) {}
  }

  return (
    <>
      {hasDuplicateError && (
        <p className={s.error}>Another company with the same name already exists</p>
      )}
      <AutosuggestInput
        type="COMPANY"
        placeholder="*Company Name"
        onChangeCb={(value, suggestions) => {
          changeCompanyProperty(value, 'name')
          validateProperty(value, suggestions)
        }}
        length="3"
        className={s.companyAutosuggest}
        initialValue={company.name}
      />
      <InputContainer
        type="text"
        text={company.legalName}
        classname={s.input}
        placeholder="*Company Legal Name"
        cb={value => changeCompanyProperty(value, 'legalName')}
      />
      <GoogleAutocomplete
        value={company.address}
        onChange={value => changeCompanyProperty(value, 'address')}
        onSelectCallback={onAddressSelectCallback}
        className={s.input}
      />
      <InputContainer
        type="text"
        classname={s.input}
        placeholder="Street 1"
        cb={value => changeCompanyProperty(value, 'address2')}
        text={company.address2}
      />
      <InputContainer
        type="text"
        classname={s.input}
        placeholder="Street 2"
        cb={value => changeCompanyProperty(value, 'street2')}
        text={company.street2}
      />
      <InputContainer
        type="text"
        classname={s.input}
        placeholder="Enter City"
        cb={value => changeCompanyProperty(value, 'city')}
        text={company.city}
      />
      <InputContainer
        type="text"
        classname={s.input}
        placeholder="Enter State/Province/Region"
        cb={value => changeCompanyProperty(value, 'state')}
        text={company.state}
      />
      <InputContainer
        type="text"
        classname={s.input}
        placeholder="Enter Zip/Postal Code"
        cb={value => changeCompanyProperty(value, 'zipcode')}
        text={company.zipcode}
      />
      <InputContainer
        type="text"
        classname={s.input}
        text={company.country}
        placeholder="Enter Country"
        cb={value => changeCompanyProperty(value, 'country')}
      />
      <InputContainer
        type="text"
        classname={s.input}
        placeholder="Enter Phone"
        cb={value => changeCompanyProperty(value, 'phone')}
        text={company.phone}
      />
      <InputContainer
        type="text"
        classname={s.input}
        placeholder="Enter Additional Phone"
        cb={value => changeCompanyProperty(value, 'additionalPhone')}
        text={company.additionalPhone}
      />
      <InputContainer
        type="text"
        classname={s.input}
        placeholder="Enter Fax"
        cb={value => changeCompanyProperty(value, 'fax')}
        text={company.fax}
      />
      <Button
        disabled={!company.name || !company.legalName}
        className={cn(s.saveBtn, s.btnPosition)}
        onClick={saveCompany}
      >
        Save Company
      </Button>
    </>
  )
}

export default AddCompany
